import { useTranslation } from 'react-i18next';
import { FaCoffee } from 'react-icons/fa';

const Spinner = ({ message }) => {
  const { t } = useTranslation();

  // Usa el mensaje proporcionado, o el texto por defecto traducido si no se proporciona ninguno.
  const loadingText = message || t('common.loading');

  return (
    <div className="flex flex-col items-center justify-center gap-3 text-primary">
      <div className="relative h-12 w-12">
        <div className="absolute inset-0 border-4 border-primary/20 rounded-full"></div>
        <div className="absolute inset-0 border-t-4 border-t-primary rounded-full animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <FaCoffee className="text-xl" />
        </div>
      </div>
      <p className="text-neutral-500 dark:text-neutral-400 font-semibold text-sm">
        {loadingText}
      </p>
    </div>
  );
};

export default Spinner;
